/**
 * Codificación de documentos: {PROCESO}-{TIPO}-{NNN}, revisiones NN, y el nombre canónico del
 * archivo {CÓDIGO}_Rev{NN}.{ext}. Es la regla de CSGestión, confirmada en el recorrido del
 * sistema en vivo (2026-10-14): los códigos importados se respetan tal cual.
 */

const CODIGO_RE = /^([A-Z]{2,4})-([A-Z]{2,4})-(\d{3})$/;

type CodigoDocumento = { proceso: string; tipo: string; correlativo: number };

export function formatearCodigo(proceso: string, tipo: string, correlativo: number): string {
  if (!Number.isInteger(correlativo) || correlativo < 1 || correlativo > 999) {
    throw new RangeError(`Correlativo fuera de rango: ${correlativo}`);
  }
  return `${proceso.toUpperCase()}-${tipo.toUpperCase()}-${String(correlativo).padStart(3, "0")}`;
}

export function parsearCodigo(codigo: string): CodigoDocumento | null {
  const m = CODIGO_RE.exec(codigo.trim().toUpperCase());
  if (!m) return null;
  return { proceso: m[1] as string, tipo: m[2] as string, correlativo: Number(m[3]) };
}

export function esCodigoValido(codigo: string): boolean {
  return parsearCodigo(codigo) !== null;
}

export function formatearRevision(numero: number): string {
  if (!Number.isInteger(numero) || numero < 1) throw new RangeError(`Revisión inválida: ${numero}`);
  return String(numero).padStart(2, "0");
}

export function nombreArchivoCanonico(codigo: string, revision: number, extension: string): string {
  const ext = extension.replace(/^\./, "").toLowerCase();
  return `${codigo}_Rev${formatearRevision(revision)}.${ext}`;
}

/**
 * Fase 5 · El número de revisión que trae el nombre de un archivo del historial:
 * "LOG-PRO-002_Rev03.docx", "Recepción rev 3.pdf", "R02 recepción.pdf", "Revisión 4.pdf".
 * Null si no lo dice (o si dice algo fuera de 1–99).
 */
export function revisionDelNombre(nombre: string): number | null {
  const m = /(?:^|[^a-z])r(?:ev(?:isi[oó]n)?)?[\s._-]*0*(\d{1,2})(?!\d)/i.exec(nombre);
  const n = m ? Number(m[1]) : Number.NaN;
  return n >= 1 && n <= 99 ? n : null;
}
